// extracted by mini-css-extract-plugin
export var hsButton = "hs-button-dr-module--hs-button--5a663";
export var icon = "hs-button-dr-module--icon--4a3e1";
export var iconBack = "hs-button-dr-module--icon-back--3670b";
export var iconClose = "hs-button-dr-module--icon-close--0c9c9";
export var iconDelete = "hs-button-dr-module--icon-delete--99f2b";
export var iconPlus = "hs-button-dr-module--icon-plus--58873";
export var primary = "hs-button-dr-module--primary--7f7fc";
export var secondary = "hs-button-dr-module--secondary--9e545";
export var sizeLarge = "hs-button-dr-module--size-large--4d120";
export var sizeSmall = "hs-button-dr-module--size-small--67e74";
export var sizeStandard = "hs-button-dr-module--size-standard--76504";